<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1200">

          <v-card style="margin: auto" width="1200">
            <!--===== TABELA QUE LISTA OS EMOLUMENTOS ======-->
            <v-data-table :headers="headers" :items="emolumentosAll" class="elevation-3">
              <template v-slot:item.status_="{ item }">
                <span>{{ item.status_ == 1 ? "Activo" : "Desativado" }}</span>
              </template>
              <template v-slot:item.precoSemIva="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.precoSemIva) }}</span>
              </template>
              <template v-slot:item.precoSemIvaTarde="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.precoSemIvaTarde) }}</span>
              </template>
              <template v-slot:item.precoSemIvaNoite="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.precoSemIvaNoite) }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-menu bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="showEditarPreco(item)">
                      <v-icon color="#006699" small>edit</v-icon> Editar Preço
                    </v-list-item>
                    <v-list-item @click="eliminarItem(item)">
                      <v-icon color="red" small>delete</v-icon> Eliminar
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
            <!--===== TABELA QUE LISTA OS EMOLUMENTOS ======-->
          </v-card>

          <!--===== EDITAR PREÇO =====-->
          <v-dialog v-if="editedItem" v-model="editarPrecoEmolumento" persistent max-width="600px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="editedItem.id" label="idEmolumento" rounded :disabled="true"></v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="editedItem.descricao" label="Emolumento" rounded
                          :disabled="true"></v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="editedItem.precoSemIva" label="Manhã" rounded
                          :disabled="true"></v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="editedItem.precoSemIvaTarde" label="Tarde" rounded
                          :disabled="true"></v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="editedItem.precoSemIvaNoite" label="Noite" rounded
                          :disabled="true"></v-combobox>
                      </div>
                    </v-col>
                    <!-- DEFINIR O TIPO DE PREÇO POR PERÍODO -->
                    <v-col cols="12" sm="12" md="12">
                      <v-select :items="definirPrecoPeriodo" v-model="definirPrecoPeriodoSelected" item-text="descricao"
                        item-value="id" label="Preço por período" @change="SelecionaDefinirPrecoPeriodo()" filled
                        outlined></v-select>
                    </v-col>
                    <!-- FIM DEFINIR O TIPO DE PREÇO POR PERÍODO -->

                    <!--====== DEFINIR VALORES ========== -->
                    <v-col cols="4" sm="4" md="4" v-if="definirPrecoPeriodoSelected">
                      <v-text-field outlined v-model="precoManha" :rules="ruleRequired" v-money="money"
                        @keyup="ObterPrecoDescricaoManha()" label="Preço Período da manhã">
                      </v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" v-if="definirPrecoPeriodoSelected">
                      <v-text-field outlined v-model="precoManhaDescricao" :disabled="true"
                        label="Preço por compreensão"></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4" v-if="isPrecoDiferente">
                      <v-text-field outlined v-model="precoTarde" :rules="ruleRequired" v-money="money"
                        @keyup="ObterPrecoDescricaoTarde()" label="Preço Período da tarde">
                      </v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" v-if="isPrecoDiferente">
                      <v-text-field outlined v-model="precoTardeDescricao" :disabled="true"
                        label="Preço por compreensão"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="isPrecoDiferente">
                      <v-text-field outlined v-model="precoNoite" :rules="ruleRequired" v-money="money"
                        @keyup="ObterPrecoDescricaoNoite()" label="Preço Período da noite">
                      </v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" v-if="isPrecoDiferente">
                      <v-text-field outlined v-model="precoNoiteDescricao" :disabled="true"
                        label="Preço por compreensão"></v-text-field>
                    </v-col>
                    <!--====== FIM DEFINIR VALOR ========== -->
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="fecharEditar()">
                  Fechar
                </v-btn>
                <v-btn color="green darken-1" :disabled="!definirPrecoPeriodoSelected" text @click="actualizarDados()">
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
const numero = require('numero-por-extenso')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    headers: [
      { text: "idEmolumento", value: "id" },
      { text: "Descrição", value: "descricao" },
      { text: "Curso", value: "curso" },
      { text: "Classe", value: "classe" },
      { text: "Manhã", value: "precoSemIva" },
      { text: "Tarde", value: "precoSemIvaTarde" },
      { text: "Noite", value: "precoSemIvaNoite" },
      { text: "Estado", value: "status_" },
      { text: "Autor", value: "autor" },
      { text: "Ações", value: "action" },
    ],
    emolumentosAll: [],
    editarPrecoEmolumento: false,
    editedItem: null,
    definirPrecoPeriodo: [
      { id: 1, descricao: 'Mesmo valor por período' },
      { id: 2, descricao: 'Diferentes valores por períodos' }
    ],
    definirPrecoPeriodoSelected: null,
    isPrecoUnico: false,
    isPrecoDiferente: false,
    precoManhaDescricao: '',
    precoManha: undefined,
    precoTarde: undefined,
    precoTardeDescricao: '',
    precoNoite: undefined,
    precoNoiteDescricao: '',
    utilitarios: utilitarios,
    isLoading: false
  }),

  created() {
    if (!this.$store.state.idEmolumento) {
      this.$router.push('/emolumentos');
    } else {
      this.getEmolumentoById()
    }
  },


  computed: {
    usuario() {
      return ls.get("nomeUsuario");
    },
  },

  methods: {

    async getEmolumentoById() {
      this.isLoading = true;
      try {
        const response = await axios.get(`getAllEmolumentosById/${this.$store.state.idEmolumento}/${this.$store.state.anoSelected}`);
        this.emolumentosAll = response.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os emolumentos', 'error')
      } finally {
        this.isLoading = false;
      }
    },


    showEditarPreco(item) {
      this.editarPrecoEmolumento = true;
      this.editedItem = item;
    },

    eliminarItem(item) {
      try {
        Swal.fire({
        title: "Eliminar Registro",
        text: "Ao confirmar, o processo de eliminação será executado, deseja continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then( async (result) => {
        if (result.isConfirmed) {
          let response = await axios.post("/anularProduto", item).then((res) => res.data);
          if (response.affectedRows >= 1) {
            Swal.fire('Sucesso', 'Registro Eliminado com Sucesso!', 'success')
            this.getEmolumentoById()
          } else {
            Swal.fire('Informação', 'Erro ao eliminar registro!', 'error')
          }          
        }
      });
      } catch (error) {
        Swal.fire('Informação', 'Erro ao eliminar registro!', 'error')
        
      }
    },

    fecharEditar() {
      this.editarPrecoEmolumento = false;
      this.getEmolumentoById();
      this.precoManha = undefined
      this.precoManhaDescricao = ''
      this.precoNoite = undefined
      this.precoNoiteDescricao = ''
      this.precoTarde = undefined
      this.precoTardeDescricao = ''
      this.definirPrecoPeriodoSelected = null
    },

    SelecionaDefinirPrecoPeriodo() {
      if (this.definirPrecoPeriodoSelected == 1) {
        this.isPrecoUnico = true;
        this.isPrecoDiferente = false;
      } else if (this.definirPrecoPeriodoSelected == 2) {
        this.isPrecoUnico = false;
        this.isPrecoDiferente = true;
      }
    },

    ObterPrecoDescricaoManha() {
      let result = utilitarios.MoneyValueToInteger(this.precoManha)
      if (result <= 0) {
        this.precoManhaDescricao = ''
        this.precoManha = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoManhaDescricao = valor + ' Kwanza(s)'
      }
    },

    ObterPrecoDescricaoTarde() {
      let result = utilitarios.MoneyValueToInteger(this.precoTarde)
      if (result <= 0) {
        this.precoTardeDescricao = ''
        this.precoTarde = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoTardeDescricao = valor + ' Kwanza(s)'
      }
    },

    ObterPrecoDescricaoNoite() {
      let result = utilitarios.MoneyValueToInteger(this.precoNoite)
      if (result <= 0) {
        this.precoNoiteDescricao = ''
        this.precoNoite = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoNoiteDescricao = valor + ' Kwanza(s)'
      }
    },


    // Actualizando os dados da instituição
    async actualizarDados() {
      try {
        let manha = this.precoManha ? utilitarios.MoneyValueToInteger(this.precoManha) : 0
        let tarde = this.precoTarde ? utilitarios.MoneyValueToInteger(this.precoTarde) : 0
        let noite = this.precoNoite ? utilitarios.MoneyValueToInteger(this.precoNoite) : 0

        if (this.isPrecoUnico && !manha) {
          Swal.fire('Informação', 'Por favor! Digite o novo preço.', 'info')
        } else if (this.isPrecoDiferente && (!manha || !tarde || !noite)) {
          Swal.fire('Informação', 'Por favor! Digite todos os preços.', 'info')
        } else if (!this.definirPrecoPeriodoSelected) {
          Swal.fire('Info', 'Selecione o tipo de preço por periódo!', 'info')
        } else {          
          let params = {
            manha: manha,
            manhaDescricao: this.precoManhaDescricao,
            tarde: this.isPrecoDiferente ? tarde : manha,
            noite: this.isPrecoDiferente ? noite : manha,
            idEmolumento: this.editedItem.id,
            autor: this.usuario,
            classeId: this.editedItem.classe_id,
            cursoId: this.editedItem.curso_id,
            pkProduto: this.editedItem.pkProduto,
            emolumento: this.editedItem.descricao,
            precoPorPeriodo: this.definirPrecoPeriodoSelected
          }

          let htmlContent = `
            <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Ao confirmar esta operação, o preço será atualizado na tabela produto, e também serão ajustados os registros na tabela items_de_venda onde o status é igual a 0 (não pago).</p>
            <div style="width: 90%; margin: 10 auto;">
              <div style="display: grid; grid-template-columns: 150px auto;">
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Emolumento:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.emolumento}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>idEmolumento:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.idEmolumento}</div>`;

          htmlContent += `
          <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Preço (Manhã):</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${utilitarios.IntegerToMoneyValueFatura(params.manha)
            }</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Preço )Tarde):</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${utilitarios.IntegerToMoneyValueFatura(params.tarde)}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Preço (Noite):</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${utilitarios.IntegerToMoneyValueFatura(params.noite)
            }</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Autor:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.autor}</div>
              </div>
            </div>
          `;

          Swal.fire({
            title: "Editar Preço",
            html: htmlContent,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Finalizar",
            reverseButtons: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.isLoading = true;
              this.editarPrecoEmolumento = false;
              try {
                let result = await axios.post("/editarPrecoEmolumento", params).then((res) => res.data);
                if (result == 'Sucesso') {
                  Swal.fire('Sucesso', 'Preço atualizado com sucesso!', 'success')
                  this.fecharEditar()
                } else {
                  Swal.fire('Erro', 'Erro ao realizar a operação', 'error')
                }
              } catch (error) {
                Swal.fire('Erro', 'Erro ao realizar a operação', 'error')
              } finally {
                this.isLoading = false;
              }
            }
          });
        }
      } catch (error) {
        Swal.fire('Erro', 'Erro ao realizar a operação', 'error')
      }
    }
  }
};
</script>

<style scoped>
.bg {
  color: green;
  background: red;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}
</style>